export enum localStorageItems {
  notHiringFirstTime = 'notHiringFirstTime',
  allowEdition = 'allowEdition',
}
